const fetchPageData = null;
export default fetchPageData;
